import { ConsoleRequest, DataProviderType } from 'apps/webcomponents/src/utils/request';
import { ComplexSuggestedItem } from 'apps/webcomponents/src/ui/gzComplexEnumList/types';
import { getCompanyExtraFilterForComplexEnumFilterCallback } from 'apps/webcomponents/src/riskManagement/common/utils';
import { WEB_COMPONENT_BREACH_PATH_APP } from 'apps/webcomponents/src/webcomponents.constants';

export class BreachPathCloudAccountIds {
  /**
   *
   * @param page
   * @param limit
   * @param searchString
   * @param filters
   * @protected
   */
  static async getRemoteData(page, limit, searchString: string = '', filters: Array<any> = []): Promise<Array<any>> {
    // Pagination is not supported for distinct filters
    if (page > 1) {
      return [];
    }
    
    return await ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.CORE,
      endpoint: 'BreachPathIssues',
      method: 'getBreachPathCloudAccountIds',
      payload: {
        searchString,
        filters,
      },
    });
  }

  /**
   *
   * @param response
   * @protected
   */
  static convertResponse(response): ComplexSuggestedItem[] {
    return response;
  }

  static getExtraFilters(): Array<any> {
    return getCompanyExtraFilterForComplexEnumFilterCallback(WEB_COMPONENT_BREACH_PATH_APP);
  }
}
